<template>
    <form method="post" action="#" id="formRole" autocomplete="off">
        <h6 class="heading-small text-muted mb-4">Role information</h6>
        <div class="pl-lg-4">
            <div class="form-group">
                <label class="form-control-label" for="input-name">Name</label>
                <input type="text" name="name" id="input-name"
                       class="form-control"
                       required
                       placeholder="Name" v-model="form.name" autofocus>
                <span  v-if="errors.hasOwnProperty('name')" class="invalid-feedback" role="alert" style="display: block;">
                    <strong>{{errors.name[0]}}</strong>
                </span>

            </div>

            <div class="form-group">
                <label class="form-control-label" for="input-home_page">Home Page (route)</label>
                <input type="text" name="home_page" id="input-home_page"
                       class="form-control"
                       placeholder="Home Page" v-model="form.home_page">
                <span  v-if="errors.hasOwnProperty('home_page')" class="invalid-feedback" role="alert" style="display: block;">
                    <strong>{{errors.home_page[0]}}</strong>
                </span>
            </div>


            <div class="form-group">
                <label class="form-control-label"
                       for="description">Description</label>
                <textarea name="description" id="description" cols="30" rows="10"
                          class="form-control" v-model="form.description"></textarea>
                <span  v-if="errors.hasOwnProperty('description')" class="invalid-feedback" role="alert" style="display: block;">
                    <strong>{{errors.description[0]}}</strong>
                </span>
            </div>

            <div class="form-row">
                <div class="form-group col-md-12">
                    <div class="form-group row">
                        <label class="col-md-12 my-2 control-label">Check the boxes you wish to grant user permission
                            to:</label>
                        <div class="col-12 app-roles">
                            <table class="table tableRoles table-hover">
                                <thead>
                                <tr>
                                    <th class="text-left">Module</th>
                                    <th class="text-center"><label><input type="checkbox"
                                                                          @change="setAllPermission('view')"
                                                                          v-model="all.view"> View</label>
                                    </th>
                                    <th class="text-center"><label><input type="checkbox"
                                                                          @change="setAllPermission('create')"
                                                                          v-model="all.create"> Create</label>
                                    </th>
                                    <th class="text-center"><label><input type="checkbox"
                                                                          @change="setAllPermission('update')"
                                                                          v-model="all.update"> Update</label>
                                    </th>
                                    <th class="text-center"><label><input type="checkbox"
                                                                          @change="setAllPermission('delete')"
                                                                          v-model="all.delete"> Delete</label>
                                    </th>
                                    <th class="text-center"><label><input type="checkbox"
                                                                          @change="setAllPermission('index')"
                                                                          v-model="all.index"> Index</label>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <slot v-for="(item, index) in items">
                                    <role-permission-section v-if="item.root && item.childrens.length === 0"
                                                             @checkModule="checkModule"
                                                             @moduleAll="moduleAll"
                                                             @check :key="'root'+index"
                                                             :section="item">

                                    </role-permission-section>
                                    <slot v-else>
                                        <tr>
                                            <td colspan="6"><label><input v-model="item.module"
                                                                          @change="moduleParentAll(item)"
                                                                          type="checkbox"> {{ item.name }}</label>
                                            </td>
                                        </tr>
                                        <slot v-for="(children, indexChildren) in item.childrens">
                                            <role-permission-section @checkModule="checkModule"
                                                                     @moduleAll="moduleAll"
                                                                     :child="true"
                                                                     :key="'child'+indexChildren"
                                                                     :parent="item"
                                                                     :section="children">
                                            </role-permission-section>
                                        </slot>
                                    </slot>

                                </slot>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>


            <div class="text-center">
                <button type="submit" @click.prevent="submit" class="btn btn-success mt-4">
                    {{ form.id ? 'Update' : 'Create' }}
                </button>
            </div>
        </div>
    </form>

</template>

<script>

export default {
    name: "RoleManagement",
    props: {
        role: {
            type: Object,
            required: false
        },
        permissions: {
            type: Array,
            default: {}
        },
        rolePermissions: {
            type: Array,
            default: {}
        },
    },
    data() {
        return {
            items: [],
            form: {
                id: null,
                name: '',
                home_page: '',
                description: ''
            },
            all: {
                view: true,
                create: true,
                update: true,
                delete: true,
                index: true,
            },
            errors: {
            }
        }
    },
    mounted() {
        if (this.role) {
            this.form = this.role
        }
        this.items = this.permissions.map((el) => {
            el["actions"] = this.checkRolePermissions(el)
            el["childrens"] = el.childrens.map((c) => {
                c["actions"] = this.checkRolePermissions(c)
                c['module'] = false
                return c;
            })
            el['module'] = false
            return el;
        });

        this.checkInitialPermission()
        this.checkModuleParentAll()
    },
    methods: {
        checkRolePermissions(menu) {
            for (let i = 0; i < this.rolePermissions.length; i++) {
                if (parseInt(this.rolePermissions[i].id) === parseInt(menu.id)) {
                    return this.rolePermissions[i].actions;
                }
            }
            return {
                view: false,
                create: false,
                update: false,
                delete: false,
                index: false,
            }

        },
        checkModule(module, parent = null) {
            let actions = Object.entries(module.actions);
            this.checkModuleParentAll()
            for (let i = 0; i < actions.length; i++) {
                if (!actions[i][1]) {
                    module.module = false;
                    if (parent) this.checkModuleParent(parent);
                    return false;
                }
            }
            module.module = true;
            if (parent) this.checkModuleParent(parent);
            return true;
        },
        checkModuleParent(module) {
            for (let i = 0; i < module.childrens.length; i++) {
                if (!this.checkModule(module.childrens[i])) {
                    module.module = false;
                    return false;
                }
            }
            module.module = true;
            return true;
        },
        moduleAll(module) {
            if (module.module) {
                module.actions.view = true
                module.actions.create = true
                module.actions.update = true
                module.actions.delete = true
                module.actions.index = true
            } else {
                module.actions.view = false
                module.actions.create = false
                module.actions.update = false
                module.actions.delete = false
                module.actions.index = false
            }

        },
        moduleParentAll(module) {
            for (let i = 0; i < module.childrens.length; i++) {
                if (module.module) {
                    module.childrens[i].module = true
                } else {
                    module.childrens[i].module = false
                }
                this.moduleAll(module.childrens[i])
            }

            this.checkModuleParent(module)
        },
        checkModuleAll(module) {
            if (!module.actions.view) {
                this.all.view = false;
            }

            if (!module.actions.create) {
                this.all.create = false;
            }

            if (!module.actions.update) {
                this.all.update = false;
            }

            if (!module.actions.delete) {
                this.all.delete = false;
            }

            if (!module.actions.index) {
                this.all.index = false;
            }

            return (!this.all.view && !this.all.create && !this.all.update && !this.all.delete && !this.all.index)

        },
        checkModuleParentAll() {
            this.all = {
                view: true,
                create: true,
                update: true,
                delete: true,
                index: true,
            };
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].childrens.length > 0) {
                    for (let j = 0; j < this.items[i].childrens.length; j++) {
                        if (this.checkModuleAll(this.items[i].childrens[j])) {
                            return
                        }
                    }
                } else {
                    this.checkModuleAll(this.items[i])
                }
            }

        },
        setAllPermission(action) {
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].childrens.length > 0) {
                    for (let j = 0; j < this.items[i].childrens.length; j++) {
                        this.items[i].childrens[j].actions[action] = this.all[action];
                    }
                } else {
                    this.items[i].actions[action] = this.all[action];
                }
            }
        },
        checkInitialPermission() {
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].childrens.length > 0) {
                    this.checkModuleParent(this.items[i])
                } else {
                    this.checkModule(this.items[i]);
                }
            }
        },
        submit() {
            let form = document.forms.namedItem("formRole");
            let Data = new FormData(form);

            let url = "/role/store";
            Data.append("permissions", JSON.stringify(this.items));

            if (this.form.id) {
                this.method = "put";
                Data.append("_method", this.method);
                url = "/role/" + this.form.id;
            }
            return this.save(url, Data);
        },
        async save(url, data) {
            axios
                .post(url, data)
                .then(() => {
                    showMessage("s", "Role successfully saved.");
                    setTimeout(function () {
                        window.location.href = '/role'
                    }, 500)

                })
                .catch(error => {

                    if (error.hasOwnProperty('response')) {
                        if (error.response.data.hasOwnProperty('errors')) {
                            this.errors = error.response.data.errors;
                        }
                    }

                    if (error.response.status === 500) {
                        showMessage(
                            "e",
                            "Role Error"
                        );
                    }

                    if (error.response.status === 401) {
                        showMessage("w", error.response.data.server_error);
                    }

                    if (error.response.status === 400) {
                        this.errors = error.response.data.errors || {};
                        showMessage(
                            "w",
                            "Fields is required"
                        );
                    }
                })
        },
    }
}
</script>

<style scoped>

</style>
